import styled from 'styled-components';

import TransactionDoneModalLogo from './assets/transaction-done-modal-logo.svg';
import TransactionDoneModalExitLogo from './assets/exit-logo.svg';

type ButtonProps = {
  disabled?: boolean;
};

export const TransactionDoneModalContainer = styled.div`
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: black;
  background-color: rgba(0, 0, 0, 0.4);
  -webkit-transition: 0.5s;
  overflow: auto;
  transition: all 0.3s linear;
`;

export const TransactionDoneModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border: 1px solid #e3e7eb;
  max-width: 500px;
  padding: 26px 30px;
  border-radius: 16px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
`;

export const TransactionDoneModalExitButton = styled.button`
  outline: none;
  background: none;
  border: none;
  position: absolute;
  left: 95.5%;
  right: 0%;
  top: -0.5%;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  cursor: pointer;
`;

export const TransactionDoneModalExit = styled.img.attrs({
  src: `${TransactionDoneModalExitLogo}`,
})`
  width: 25px;
  height: 25px;
  background-color: white;
  cursor: hover;
  border-radius: 50%;
`;

export const TransactionDoneModalLogoImg = styled.img.attrs({
  src: `${TransactionDoneModalLogo}`,
})`
  margin-top: 25px;
  width: 200px;
  height: 195px;
`;

export const TransactionDoneModalTitle = styled.div`
  margin-top: 24px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 150%;

  color: #183b56;
`;

export const TransactionDoneModalSubTitle = styled.div`
  margin-top: 4px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  text-align: center;

  color: #74899a;
`;

export const TransactionDoneModalTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  top: 0px;
  margin: 10px;
  background: #f3f5f7;
  border: 1px solid #e3e7eb;
  width: 440px;
  height: 300px;
  border-radius: 16px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
`;

export const TransactionDoneModalStepsTitle = styled.div`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 159%;
  padding: 0px 30px;
  margin-top: 24px;
  color: #74899a;
`;

export const TransactionDoneModalStepsNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  border-radius: 50%;
  width: 40px;
  height: 40px;
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 150%;

  background: linear-gradient(180deg, #566ffe 0%, #18a0fb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const TransactionDoneModalListStepsWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const TransactionDoneModalStepsWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: center;
`;

export const TransactionDoneModalStepsText = styled.div`
  padding-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #183b56;
`;

export const TransactionDoneModalHashText = styled.span`
  font-family: 'Montserrat';
  text-align: center;
  font-style: normal;
  margin-top: 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 159%;
  color: #000;
`;

export const TransactionDoneModalButton = styled.button<ButtonProps>`
  width: 380px;
  height: 40px;
  margin-top: 24px;
  background: none;
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;

  color: #ffffff;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  font-family: 'Montserrat';
  font-style: normal;

  background: linear-gradient(180deg, #566ffe 0%, #18a0fb 100%);
  border-radius: 40px;
  transition: all 0.3s ease-in-out;

  &:hover {
    opacity: 0.8;
  }

  ${(props) =>
    props.disabled
      ? `
          opacity: 0.7;
          pointer-events: none;
          `
      : ''}

  .copyWindow {
    display: flex;
    justify-content: center;
    align-items: center;
    visibility: hidden;
    opacity: 0;
    position: absolute;
    margin-bottom: 6rem;
    background: #000000;
    color: #fff;
    height: 30px;
    width: 80px;
    border-radius: 8px;
    transition: visibility 0.2s linear, opacity 0.2s linear;
  }

  .copyWindow::after {
    content: '';
    position: absolute;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #000;
    bottom: -20%;
  }

  .visible {
    visibility: visible;
    opacity: 1;
  }
`;

export const TransactionDoneModalLink = styled.span`
  margin-top: 24px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;

  display: flex;
  align-items: center;
  text-align: center;
  text-decoration-line: underline;
  text-transform: capitalize;

  background: linear-gradient(180deg, #566ffe 0%, #18a0fb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const HashAddress = styled.span`
  margin-top: 16px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;

  display: flex;
  align-items: center;
  text-align: center;
  text-decoration-line: underline;
  text-transform: capitalize;

  background: linear-gradient(180deg, #566ffe 0%, #18a0fb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;
